export enum ScreenSizes {
  laptopMedium = 1359,
  laptopSmall = 1023,
  tablet = 767,
  mobile = 575
}
